<template>
  <div class="form-group portal-select">
    <label v-if="title.length > 0">
      {{ title }}
      <span class="text-danger" v-if="required">*</span>
    </label>

    <v-select v-bind="$attrs" v-on="$listeners" v-model="form[name]">
      <!-- Pass on all named slots -->
      <slot v-for="slot in Object.keys($slots)" :name="slot" :slot="slot" />
      <!-- Pass on all scoped slots -->
      <template v-for="slot in Object.keys($scopedSlots)" :slot="slot" slot-scope="scope">
        <slot :name="slot" v-bind="scope" />
      </template>
    </v-select>
    <suc-field-has-error :form="form" :field="name" />
  </div>
</template>

<script>
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { Form } from "@/components/form";
import SucFieldHasError from "@/components/form/SucFieldHasError.vue";

export default {
  name: "SucSelect",
  props: {
    name: {
      type: String,
      required: true,
    },
    form: {
      type: Form,
      required: true,
    },
    title: {
      type: String,
      default: "",
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    vSelect,
    SucFieldHasError,
  },
  data() {
    return {
      value: null,
    };
  },
};
</script>

<style lang="scss">
.portal-select {
  .v-select {
    .vs__dropdown-toggle {
      min-height: 44px;
      padding: 2px 6px;
      border: 1px solid var(--portal-border);
      border-radius: 12px;
      background: var(--portal-input-bg);
      transition: border-color 0.2s ease, box-shadow 0.2s ease;
    }

    &.vs--open .vs__dropdown-toggle,
    .vs__dropdown-toggle:focus-within {
      border-color: var(--portal-primary);
      box-shadow: 0 0 0 3px var(--portal-ring);
    }

    .vs__selected {
      margin: 4px 2px 0;
      color: var(--portal-text);
      font-size: 0.92rem;
      font-weight: 600;
    }

    .vs__search,
    .vs__search:focus {
      margin: 0;
      color: var(--portal-text);
      font-size: 0.92rem;
    }

    .vs__actions {
      padding-right: 8px;
    }

    .vs__clear,
    .vs__open-indicator {
      fill: var(--portal-text-muted);
    }

    .vs__dropdown-menu {
      margin-top: 6px;
      padding: 0.4rem;
      border: 1px solid var(--portal-border);
      border-radius: 14px;
      background: var(--portal-surface);
      box-shadow: var(--portal-shadow);
      color: var(--portal-text);
    }

    .vs__dropdown-option {
      padding: 0.65rem 0.75rem;
      border-radius: 10px;
      color: var(--portal-text);
      font-size: 0.9rem;
      font-weight: 500;
    }

    .vs__dropdown-option--highlight {
      background: var(--portal-primary);
      color: #fff;
    }

    .vs__dropdown-option--selected {
      background: var(--portal-primary-soft);
      color: var(--portal-primary);
      font-weight: 700;
    }
  }
}
</style>
